<p-toast [style]="{marginTop: '80px'}"></p-toast>

<p-table [value]="filteredReviews" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25, 50, 100]"
  showCurrentPageReport="true" currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
  [loading]="formLoading" styleClass="p-datatable-striped" [autoLayout]="true" [responsive]="true"
  selectionMode="single" (onRowSelect)="onRowSelect($event.data)">

  <ng-template pTemplate="caption">
    <div class="d-flex justify-content-between align-items-center">
      <span class="d-flex align-items-center">
        <h1 style="margin: 6px; margin-right: 15px;">VRBO Reviews</h1>
        <input type="text" pInputText placeholder="Search reviews..."
          (input)="onGlobalFilter($event.target.value)" style="width: 250px; margin-right: 10px;">

          <p-dropdown [options]="properties" optionLabel="propertyCode" optionValue="shortTermRentalId"
            placeholder="Filter by Property" [showClear]="true" [(ngModel)]="selectedShortTermRentalId"
            (onChange)="onPropertyFilterChange()" [style]="{'min-width': '200px', 'margin-right': '10px'}">
          </p-dropdown>
        </span>

        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important;"
        (click)="loadData()">Refresh</button>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th>Property</th>
        <th>Rating</th>
        <th>Title</th>
        <th>Review</th>
        <th>Reviewer</th>
        <th>Date</th>
        <th>Status</th>
        <th>Response</th>
        <th>Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-review>
      <tr [pSelectableRow]="review" style="cursor: pointer;">
        <td>{{review.propertyCode}}</td>
        <td>
          <p-rating [(ngModel)]="review.overallRating" [readonly]="true" [stars]="5" [cancel]="false"></p-rating>
        </td>
        <td class="fixdata"><b>{{review.titleValue}}</b></td>
        <td class="fixdata">{{truncate(review.bodyValue, 80)}}</td>
        <td>{{review.reviewerName}}</td>
        <td>{{review.submittedDateValue | date:'mediumDate'}}</td>
        <td>{{review.statusLabel}}</td>
        <td style="text-align: center;">
          <p-checkbox [(ngModel)]="review.hasResponse" [binary]="true" [readonly]="true"></p-checkbox>
        </td>
        <td>
          @if (review.isEligibleForResponse && !review.hasResponse) {
            <button pButton pRipple
              class="p-button-outlined p-button-sm p-button-info" style="margin-right: 5px;"
            label="Respond" (click)="openRespondDialog($event, review)"></button>
          }
          <button pButton pRipple class="p-button-outlined p-button-sm p-button-success"
          label="Rate Guest" (click)="openRateGuestDialog($event, review)"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="9" style="text-align: center;">No reviews found.</td>
      </tr>
    </ng-template>
  </p-table>
